import { Pipe, PipeTransform } from '@angular/core';

const EXAM_TYPE_MAP: { keywords: string[]; bg: string; text: string }[] = [
  { keywords: ['TRIO'], bg: 'bg-exam-trio-bg', text: 'text-exam-trio-text' },
  { keywords: ['DUO'], bg: 'bg-exam-duo-bg', text: 'text-exam-duo-text' },
  { keywords: ['PANEL'], bg: 'bg-exam-panel-bg', text: 'text-exam-panel-text' },
  { keywords: ['EXOMA'], bg: 'bg-exam-exoma-bg', text: 'text-exam-exoma-text' },
  { keywords: ['GENOMA'], bg: 'bg-exam-genoma-bg', text: 'text-exam-genoma-text' },
  { keywords: ['MLPA'], bg: 'bg-exam-mlpa-bg', text: 'text-exam-mlpa-text' },
  { keywords: ['MICROARREGLOS'], bg: 'bg-exam-microarreglos-bg', text: 'text-exam-microarreglos-text' },
  { keywords: ['EXPANSION', 'TRIPLETA'], bg: 'bg-exam-expansion-bg', text: 'text-exam-expansion-text' },
  { keywords: ['TAMIZAJE', 'NEONATAL'], bg: 'bg-exam-tamizaje-bg', text: 'text-exam-tamizaje-text' },
  { keywords: ['FUTUROS', 'PADRES'], bg: 'bg-exam-futuros-bg', text: 'text-exam-futuros-text' }
];

const DEFAULT_CLASSES = 'bg-exam-default-bg text-exam-default-text';

/**
 * Pure pipe to resolve exam type badge CSS classes.
 * Angular caches the result automatically — re-evaluated only when the input reference changes.
 */
@Pipe({ name: 'examTypeBadge', standalone: true, pure: true })
export class ExamTypeBadgePipe implements PipeTransform {
  transform(examType: unknown): string {
    if (!examType) {
      return DEFAULT_CLASSES;
    }

    const str = String(examType).toUpperCase();

    for (const entry of EXAM_TYPE_MAP) {
      if (entry.keywords.some((kw) => str.includes(kw))) {
        return `${entry.bg} ${entry.text}`;
      }
    }

    return DEFAULT_CLASSES;
  }
}
